import { Route, Routes } from "react-router-dom";
import InventoryList from "./InventoryList";
import InventoryProductPage from "./InventoryProductPage";
import SubmitDeliveryPageContainer from "./SubmitDeliveryPageContainer";
import SubmitHistoryPage from "./SubmitHistoryPage";

const Inventory = () => {
  return (
    <Routes>
      <Route path="/" element={<InventoryList />} />
      <Route path="/submit-history" element={<SubmitHistoryPage />} />
      <Route
        path="/submit-delivery"
        element={<SubmitDeliveryPageContainer />}
      />
      <Route path="/:id" element={<InventoryProductPage />} />
    </Routes>
  );
};

export default Inventory;
